import script from "./btmPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./btmPagination.vue?vue&type=script&setup=true&lang=js"

import "./btmPagination.vue?vue&type=style&index=0&id=b1cb262a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1cb262a"]])

export default __exports__